"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketingOptIn = void 0;
var MarketingOptIn;
(function (MarketingOptIn) {
    MarketingOptIn["YES"] = "Y";
    MarketingOptIn["NO"] = "N";
    MarketingOptIn["UNSPECIFIED"] = "unspecified";
})(MarketingOptIn = exports.MarketingOptIn || (exports.MarketingOptIn = {}));
